import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDocumentEntityMappedItem } from '@app/logic/documents';

@Component({
    selector: 'cb-upload-brochure-dialog',
    templateUrl: './upload-brochure-dialog.component.html',
    styleUrls: ['./upload-brochure-dialog.component.scss'],
    standalone: false
})
export class UploadBrochureDialogComponent {
    public static readonly MIN_WIDTH = '400px';

    constructor(
        public readonly dialogRef: MatDialogRef<UploadBrochureDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: { documentEntity: IDocumentEntityMappedItem }
    ) { }

    public save(): void {
        this.dialogRef.close(this.data.documentEntity.document.uploadedFile);
    }

    public cancel(): void {
        this.dialogRef.close();
    }
}
